import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import { crearClienteDeConsultas } from '@/api/consultas'
import { Toaster } from '@/components/ui/sonner'
import Rutas from '@/rutas/Rutas'

const consultas = crearClienteDeConsultas()

export default function App() {
  return (
    <QueryClientProvider client={consultas}>
      <BrowserRouter>
        <Rutas />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </QueryClientProvider>
  )
}
